module.exports = __webpack_public_path__ + "img/3.98a07d60.jpg";